import { Theme, css } from '@emotion/react';
import { Typography } from 'omakase';
import { core } from '@tock/coretypes';
import { purchaseCancellationPolicyDescriptionStyles } from 'components/business/receipts/purchaseCancellationPolicyDescriptionCssDefs';
import CreditCardIcon from 'components/credit-cards/CreditCardIcon';
import React from 'react';

interface PurchaseCancellationPolicyDescriptionProps {
  businessName: string;
  description: string[];
  paymentCardHold?: core.IPaymentCardHold;
}
export const PurchaseCancellationPolicyDescription: React.FC<
  PurchaseCancellationPolicyDescriptionProps
> = ({ businessName, description, paymentCardHold }) => {
  return (
    <div
      css={(theme: Theme) => css`
        border: solid 1px ${theme.colors.borderDefault};
        background-color: ${theme.colors.bgLighter};
        padding: ${theme.spacing(2)}px;
      `}
    >
      <Typography component="h5" variant="heading04" mb={1}>
        <strong>Cancellation policy</strong>
      </Typography>
      {description.map((content) => (
        <Typography
          key={content}
          css={purchaseCancellationPolicyDescriptionStyles}
          variant="body02"
          data-testid="cancel-fee-policy"
        >
          {content}
        </Typography>
      ))}
      {paymentCardHold && (
        <div
          css={(theme: Theme) => css`
            margin-top: ${theme.spacing(2)}px;
          `}
        >
          <Typography variant="body02Strong">
            <strong>Reservation secured with</strong>
          </Typography>
          <div
            css={({ colors, spacing, borderRadius }: Theme) => css`
              background-color: ${colors.borderDefault};
              display: flex;
              padding: ${spacing(1)}px;
              margin-top: ${spacing(1)}px;
              margin-bottom: ${spacing(1)}px;
              border-radius: ${borderRadius[100]};
              align-items: center;
            `}
          >
            <CreditCardIcon brand={paymentCardHold.paymentCardBrand || undefined} />
            <Typography variant="body02">
              {paymentCardHold.paymentCardBrand} (••••
              {paymentCardHold.paymentCardMaskedNumber})
            </Typography>
          </div>
          <Typography variant="caption" color="fgSubtle">
            A no-show or late cancellation charge will appear as “Tock at*
            {businessName}” on your card statement.
          </Typography>
        </div>
      )}
    </div>
  );
};
